export default __webpack_public_path__ + "static/media/Tunga.f1c1deb0.ttf";